import { render, staticRenderFns } from "./CategoryChart.vue?vue&type=template&id=9d660976&"
import script from "./CategoryChart.vue?vue&type=script&lang=js&"
export * from "./CategoryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports